import { RESPONSE_KEY_TO_CANONICAL } from '@/helpers/brandFilterDefinitions'

// WatchlistCheckerService (backend) expects a flat { attribute: value|value[] } map, with a
// `query` key for free-text search. Extracted so both PageBrandSearch.vue's save-from-search
// flow and WatchlistCriteriaFilters.vue's ad hoc editor flatten currentFilters the same way.
export const flattenCurrentFiltersToWatchlistFilters = (currentFilters = []) => {
  const flat = {}
  for (const item of currentFilters) {
    const values = item.refinements.map(refinement => refinement.value)
    flat[item.attribute] = values.length > 1 ? values : values[0]
  }
  return flat
}

// Reverse of the above, for seeding the detached InstantSearch instance from a watchlist's
// previously-saved `filters` — which arrives camelCase-mangled by the backend's
// TransformRequestKeys middleware (see brandFilterDefinitions.js for why).
export const filtersToInitialUiState = (filters, indexName) => {
  if (!filters) return undefined

  let query
  const refinementList = {}
  for (const [key, value] of Object.entries(filters)) {
    const canonicalKey = RESPONSE_KEY_TO_CANONICAL[key] ?? key
    if (canonicalKey === 'query') {
      query = value
      continue
    }
    refinementList[canonicalKey] = Array.isArray(value) ? value : [value]
  }

  return { [indexName]: { query, refinementList } }
}

// The raw watchlist API response (camelCase attribute names, e.g. `activeSubstances`)
// and the live InstantSearch widget's own echoed refinements (raw Typesense field
// names, e.g. `active_substances`) describe the exact same filters in two different
// key shapes. Normalize both down to one canonical, order-independent shape so
// dirty-checking (e.g. a page's "unsaved changes" indicator) doesn't false-positive
// on this superficial difference.
export const normalizeFiltersForComparison = filters => {
  if (!filters) return null
  const entries = Object.entries(filters).map(([key, value]) => {
    const canonicalKey = RESPONSE_KEY_TO_CANONICAL[key] ?? key
    const values = (Array.isArray(value) ? value : [value]).map(String).sort()
    return [canonicalKey, values]
  })
  entries.sort(([a], [b]) => a.localeCompare(b))
  return Object.fromEntries(entries)
}
